import { Autocomplete, Chip, TextField } from "@mui/material";
import { Group } from "../../../graphql/generated";
import { useTranslation } from "react-i18next";
import { testIds } from "./GroupSelect.testIds";

export type GroupSelectProps = {
  value: string[];
  onChange: (value: string[]) => void;
  groups: Pick<Group, "_id" | "name">[];
  "data-testid"?: string;
};

const GroupSelect = ({
  value,
  onChange,
  groups,
  "data-testid": dataTestId,
}: GroupSelectProps) => {
  const { t } = useTranslation("common");
  return (
    <Autocomplete data-testid={dataTestId ?? testIds.groupSelectGroupsPicker}
      value={groups.filter((group) => value.includes(group._id))}
      clearIcon={false}
      options={groups}
      multiple
      renderTags={(value, props) =>
        value.map((group, index) => (
          <Chip label={group.name} {...props({ index })} />
        ))
      }
      renderInput={(params) => (
        <TextField
          name="groups"
          label={t("groups", "Groups")}
          {...params}
          inputProps={{
            ...params.inputProps,
            "data-testid": dataTestId
              ? `${dataTestId}-input`
              : testIds.groupSelectGroupsSearch,
          }}
        />
      )}
      renderOption={(props, group) => (
        <li
          {...props}
          data-testid={`${dataTestId ?? testIds.groupSelectGroupsPicker}-option-${
            group._id
          }`}
        >
          {group.name}
        </li>
      )}
      getOptionLabel={(group) => group.name}
      onChange={(_, newValue) => {
        onChange(newValue.map((group) => group._id));
      }}
    />
  );
};

export default GroupSelect;
